import React, { useState, useEffect, useRef, lazy } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; // useDispatch

//API
import ItemService from "../../../../services/customer_v2_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";

import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
// import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import toast from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import PrintInvoice from "../Scheduling/PrintInvoice";
import { useReactToPrint } from "react-to-print";

const CustInvoiceDetailsV2 = () => {
  localStorage.setItem("menu", "Sales");
  localStorage.setItem("submenu", "Invoice");

  const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;

  const PrintInvoiceLazy = lazy(() => import("../OrderBooking/PrintInvoice"));

  let invoiceNumber = useSelector((state) => state?.preSales?.invoiceID); // invoiceNumber from Store

  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO
  ); // workflowPO from Store

  // const documentTypeMap = {
  //   "101 - GST Registration": "GST",
  //   "100 - PAN Registration": "PAN",
  //   "131 - GST Registration": "GST",
  // };

  const [lineItemData, setLineItemData] = useState();
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  const [modalShow, setModalShow] = useState(false);

  const [invoiceData, setInvoiceData] = useState();

  // send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();
  // eslint-disable-next-line
  const [getInvoiceChildData, setInvoiceChildData] = useState();

  const [showPrint, setShowPrint] = useState(false);

  //print
  useEffect(() => {
    setPrintInvoiceData(invoiceData);
  }, [invoiceData]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    onAfterPrint: () => setShowPrint(false),
    pageStyle:pageStyle
  });

  const lineItemCol = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {row?.orderQtyLoadConfirm || row?.orderQuantityLoad}{" "}
          </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Unit Price",
      cell: (row) => <span>{row?.unitPrice} </span>,
      width: "100px",
    },
    {
      name: "Ex-work",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.exWork || "--"} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Basic Price",
      selector: (row) => row?.basicPrice || "--",
      cell: (row) => <span>{row?.basicPrice} </span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.basicAmount || "--",
      cell: (row) => <span>{row.basicAmount} </span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => (
        <span>
          {/* {row?.cgstValue} */}
          {row?.isIGST ? "0" : row?.cgstValue}
        </span>
      ),

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => (
        <span>
          {/* {row?.sgstValue} */}
          {row?.isIGST ? "0" : row?.sgstValue}
        </span>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "IGST",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={row.isIGST}
            // onChange={() => handleIGSTToggle(index)}
            style={{ marginRight: "8px" }}
            disabled={true}
          />
          {row.isIGST && (
            <InputField
              type="number"
              className="inputBox"
              value={row.igstPercent || "00"}
              // onChange={(e) => handleIGSTPercentChange(e.target.value, index)}
              placeholder="%"
              style={{ width: "60px" }}
              disabled={true}
            />
          )}
        </div>
      ),

      width: "140px",
    },
    {
      name: "Net Value",
      selector: (row) => row?.netValue || "--",
      cell: (row) => <span>{row?.netValue} </span>,

      sortable: true,
      width: "120px",
    },

    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      cell: (row) => <span>{row?.isIGST ? "0" : row?.cgst} </span>,
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      cell: (row) => <span>{row?.isIGST ? "0" : row?.sgst} </span>,
      sortable: true,
      width: "100px",
    },
  ];

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    customerCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    customerInvoiceNo: "",
    customerInvoiceDate: "",
    customerInvoiceCurrency: "",
    customerBasicValue: "",
    customerFreightValue: "",
    customerTaxValue: "",
    customerOtherChargesValue: "",
    customerTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // load loadInitialPageData data on page load
  const loadInitialPageData = async () => {
    // setLoading(true);
    if (invoiceNumber) {
      let obj = {
        documentNumber: invoiceNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getCustInvoiceDatails(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setInvoiceData(item?.data[0]);
          setLineItemData(item?.data[0].items);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
      // setLoading(false);
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber]);

  // Workflow
  const navigateToWorkflow = () => {
    window.history.back();
  };
  const showApproveModal = async (name) => {
    setModalShow(true);
    // setAction(name);
  };
  const printInvoiceDataChild = (childdData) => {
    setInvoiceChildData(childdData);
    // console.log(">>Received childdData from child:", childdData);
    // You can now use this data in the parent component
  };

  //rounde value
  function roundToIntWithTwoDecimals(value) {
  const num = Number(value);

  // ⛔ protect against NaN, null, undefined, empty
  if (!Number.isFinite(num)) return "0";

  const rounded = Math.round(num);

  return String(rounded); // or `${rounded}.00`
}

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Invoice Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {invoiceNumber}
              </span>
              <span>
                {formInputs?.invoiceStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader === "Invoice Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : (
                  formInputs?.invoiceStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Invoice Details</p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={6} lg={6} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
              <Col xs={12} md={2} lg={2} className="text-left">
                {/* <button className="btnBack" onClick={handlePrint}> */}
                <button
                  className="btnBack"
                  onClick={() => {
                    setShowPrint(true);
                    setTimeout(handlePrint, 0); // ensure component mounts first
                  }}
                >
                  <i class="bi bi-printer"></i> Print
                </button>
                {showPrint && (
                  <>
                    <div /* style={{ display: "none" }} */ className="d-none">
                      <PrintInvoiceLazy
                        ref={contentRef}
                        data={printInvoiceData}
                        onsendinvoicedata={printInvoiceDataChild}
                      />
                    </div>
                  </>
                )}
              </Col>
            </Row>
            {/* <div style={{ display: "block" }}>
              <PrintInvoiceLazy ref={contentRef} data={printInvoiceData} />
            </div> */}
            <>
              {/* Invoice header */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">IH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Invoice Header</span>
                        <span className="subHeaderTitle">Invoice Header</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Col xs={12} md={12} lg={12} className="p-2">
                            <p className="mb-0 text-lg">
                              {invoiceData?.companyCodeDesc}
                            </p>
                            <p className="mb-0 text-lg">
                              {invoiceData?.companyAddress}
                            </p>
                          </Col>
                          <Col xs={12} md={12} lg={12} className="p-2">
                            <p className="fw-bold mb-0">Billing:</p>
                            <p className="text-lg mb-0">
                              {invoiceData?.customerName}
                            </p>
                            <p className="text-lg mb-0">
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.customerAddress
                                : ""}{" "}
                            </p>

                            {/* {invoiceData?.items &&
                          invoiceData.items[0]?.certifications
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                          </Col>
                          <Col xs={12} md={12} lg={12} className="p-2">
                            <p className="fw-bold mb-0">Shipping:</p>
                            <p className="text-lg mb-0">
                              {invoiceData?.customerName}
                            </p>
                            <p className="text-lg mb-0">
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.shippingAddress + " "
                                : ""}
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.shippingPostalCode
                                : ""}
                            </p>
                          </Col>
                          <Col xs={12} md={12} lg={12} className="p-2">
                            <p className="fw-bold mb-0">Godown:</p>
                            <p className="text-lg mb-0">
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.godownAddress
                                : ""}
                            </p>
                          </Col>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              {/* invoice service itme details table*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PI</span>
                      </Col>
                      <Col xs={12} md={8} lg={8}>
                        <span className="headerTitle">Items</span>
                        <span className="subHeaderTitle">Items details</span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={lineItemCol}
                            data={lineItemData}
                            // progressPending={orderSchedulingData?.status}
                            // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                            pagination
                            paginationServer
                            // paginationTotalRows={orderSchedulingTable.total}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            // onSelectedRowsChange={handleRowSelect}
                            // selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* invoice details */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>

                      <Col xs={4} md={8} lg={8}>
                        <span className="headerTitle"> Invoice details</span>
                        <span className="subHeaderTitle">Invoice details</span>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Bags"
                                  name="sumOfOrderQuantityLoad"
                                  id="sumOfOrderQuantityLoad"
                                  value={invoiceData?.totals?.totalBags ?? ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total Amount"
                                  name="sumOfRate"
                                  id="sumOfRate"
                                  value={invoiceData?.totals?.totalAmount ?? ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total CGST"
                                  name="totalCgst"
                                  id="totalCgst"
                                  value={invoiceData?.totals?.totalCgst || ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Total SGST"
                                  name="totalSgst"
                                  id="totalSgst"
                                  value={invoiceData?.totals?.totalSgst || ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Round Off"
                                  name="roundOff"
                                  id="roundOff"
                                  // value={getInvoiceChildData?.difference || ""}
                                  value={invoiceData?.roundOff || "0"}
                                  // onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={3}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Net Amount"
                                  name="netValue"
                                  id="netValue"
                                  value={roundToIntWithTwoDecimals(invoiceData?.totals?.totalNetValue) || "0"}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {invoiceData?.items &&
                                  !!invoiceData?.items[0]
                                    ?.loadingOtherTruckNo ? (
                                    <InputField
                                      className="inputBox"
                                      label="Truck No"
                                      name="loadingTruckNo"
                                      id="loadingTruckNo"
                                      value={
                                        invoiceData?.items
                                          ? invoiceData?.items[0]?.loadingOtherTruckNo.toUpperCase()
                                          : ""
                                      }
                                      onChange={onInputChange}
                                      disabled={true}
                                    />
                                  ) : (
                                    <InputField
                                      className="inputBox"
                                      label="Truck No"
                                      name="loadingTruckNo"
                                      id="loadingTruckNo"
                                      value={
                                        invoiceData?.items
                                          ? invoiceData?.items[0]
                                              ?.loadingTruckNoDescription
                                          : ""
                                      }
                                      onChange={onInputChange}
                                      disabled={true}
                                    />
                                  )}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="e-Way Bill Number"
                                    extraLabel=""
                                    name="ewayBill"
                                    code="ewayBill"
                                    description="ewayBill"
                                    // data={ewayBillNumberData}
                                    id="ewayBill"
                                    iconClassName="dropdownIcon"
                                    setValue={invoiceData?.ewayBill}
                                    // getvalue={setDropdownData}

                                    disabled={true}
                                  />
                                </Col>
                                {/* <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Dispatch Documnet Number"
                                    name="dispatchDocumnetNr"
                                    id="dispatchDocumnetNr"
                                    value={invoiceData?.dispatchDocumnetNr}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Bill of Lading / LR-RR No."
                                    name="billOfLading"
                                    id="billOfLading"
                                    value={invoiceData?.billOfLading}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Terms Of Payment"
                                    extraLabel=""
                                    name="termsOfPayment"
                                    code="termsOfPaymentCode"
                                    description="termsOfPaymentDesc"
                                    // data={dropdownOption}
                                    id="termsOfPayment"
                                    iconClassName="dropdownIcon"
                                    setValue={invoiceData?.termsOfPayment}
                                    // getvalue={setDropdownData}

                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={6}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <TextAreaField
                                    className="inputBox"
                                    label="Terms of Delivery"
                                    type="text"
                                    name="termsOfDelivery"
                                    id="termsOfDelivery"
                                    value={invoiceData?.termsOfDelivery}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col> */}
                                {/* {invoiceData?.ewayBill === "Yes" && (
                                  <Row>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Generated Date"
                                        name="generatedDate"
                                        id="generatedDate"
                                        type="date"
                                        value={
                                          invoiceData?.generatedDate ||
                                          getTodaysData()
                                        }
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Distance"
                                        name="distance"
                                        id="distance"
                                        value={invoiceData?.distance}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Supply Type"
                                        name="supplyType"
                                        id="supplyType"
                                        value={invoiceData?.supplyType}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Transaction Type"
                                        name="transactionType"
                                        id="transactionType"
                                        value={invoiceData?.transactionType}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      md={6}
                                      lg={3}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Mode"
                                        name="mode"
                                        id="mode"
                                        value={invoiceData?.mode}
                                        onChange={onInputChange}
                                        disabled={true}
                                        // disabled={!!diableEwaybill}
                                      />
                                    </Col>
                                  </Row>
                                )} */}
                              </Row>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Col>
      </Row>

      {/* Modal Workflow */}
      <ApproveRemarksModal
        show={modalShow}
        // onHide={() => hideModal()}
        // onvaluechange={handleValueChange}
      />

      {/* Success Modal Workflow */}
      {/* <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      /> */}
    </main>
  );
};

export default CustInvoiceDetailsV2;
